module.exports = __webpack_public_path__ + "img/ico-planner.451fd19b.svg";